import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
var FullLayoutComponent = /** @class */ (function () {
    function FullLayoutComponent(authService, router) {
        this.authService = authService;
        this.router = router;
        this.kairos = false;
        this.kairos = environment.kairos;
    }
    FullLayoutComponent.prototype.ngOnInit = function () {
        this.username = this.authService.username;
    };
    FullLayoutComponent.prototype.logout = function () {
        this.authService.logout();
        this.router.navigate(['login']);
    };
    FullLayoutComponent.ctorParameters = function () { return [{ type: AuthService }, { type: Router }]; };
    return FullLayoutComponent;
}());
export { FullLayoutComponent };
//# sourceMappingURL=full-layout.component.js.map


// WEBPACK FOOTER //
// full-layout.component.js